import React, {
  useRef,
  useEffect,
  useState,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from "react";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global, globalMenu } from "@shared/libs/Global";
import SharedForm from "../../../../../widgets/SharedForm";
import { fnSave } from "@shared/api/restApi";
import { menuInfo } from "@shared/type/CommonType";
import SearchPanel from "../../../../../widgets/SearchPanel";
import { showDialog } from "@widgets/CommonDialog";
import SnGrid from "@shared/components/Grid/SnGrid";
import SnResizableLNR from "@shared/components/SnResizableLNR";
import { showPopupModal } from "@widgets/CommonModal";
import SN_PRD_BAS_REG_014_POP_01 from "./SN_PRD_BAS_REG_014_POP_01";
import {
  ProcessCellForExportParams,
  ProcessHeaderForExportParams,
} from "ag-grid-community";
interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string;

  [key: string]: any;
}

const SN_PRD_BAS_REG_014 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region Component UseState
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns1, setColums1] = useState<any[]>([]);
  const [columns2, setColums2] = useState<any[]>([]);
  const [dataSource1, setDataSource1] = useState<any>();
  const [dataSource2, setDataSource2] = useState<any>();
  const [gridFocus, setGridFocus] = useState(false);
  const sheetref1 = useRef<any>(null); // excel download 용
  const [sheet1Columns, setSheet1Columns] = useState<any[]>([]); // excel 업로드용 컬럼
  const [sheetReady, setsheetReady] = useState(false); // 렌더링 완료 여부
  //#endregion

  //#region Variables
  const gridref1 = useRef<any>(null);
  const gridref2 = useRef<any>(null);
  const { userInfo } = global();
  let SaveData: any = {};
  const searchRef = useRef<any>(null);
  //#endregion

  //#region grid 길이 관련
  let width1 = "29.5%";
  let width2 = "69.5%";
  const menuSize = localStorage.getItem("menuSize");
  if (menuSize) {
    const menu = JSON.parse(menuSize);
    if (menu.SN_PRD_BAS_REG_014) {
      width1 = menu.SN_PRD_BAS_REG_014.grid1Width
        ? menu.SN_PRD_BAS_REG_014.grid1Width
        : width1;
      width2 = menu.SN_PRD_BAS_REG_014.grid2Width
        ? menu.SN_PRD_BAS_REG_014.grid2Width
        : width2;
    }
  }
  const [grid1Width, setGrid1Width] = useState<string | number>(width1);
  const [grid2Width, setGrid2Width] = useState<string | number>(width2);
  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      setDataSource1([]);
      setDataSource2([]);
      try {
        const rtn: any = await getInitFormData();
        setFormControlData(rtn.formControlData);
        setFormData(rtn.formData); // 조회조건 초기값
        setColums1(rtn.grid.grid1);
        setColums2(rtn.grid.grid2);
        setSheet1Columns(rtn.grid.sheet1); // 전체 컬럼 (엑셀용)
      } catch (error) {}
    };
    fetchform();
  }, []);

  useEffect(() => {
    gridref1.current.selectAndFocusRow(0);
    setGridFocus(false);
  }, [gridFocus]);

  //#region Button Event
  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
    onExcelUpload,
    onExcelDownLoad,
  }));

  const onSearch = async () => {
    const modifiedRows = gridref2.current.getChange();
    if (modifiedRows.modifiedRowcount > 0) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        await onSave();
      }
    }
    try {
      const params = {
        id: "sn_prd_bas_reg_014_01",
        params: searchRef.current.getFormdata(),
      };
      setDataSource1([]);
      setDataSource2([]);

      const data: any = await fnGetDataSet(params);
      setDataSource1(data[0]);
      setDataSource2(data[1]);

      if (data[0] && data[0].length > 0) {
        await new Promise((resolve) => setTimeout(resolve, 50));

        setGridFocus(true);
      }

      gridref1.current.resetUpdate();
      gridref2.current.resetUpdate();
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const onInsert = () => {
    try {
      const newRow = {};
      gridref1.current.addRow(newRow);
      /*setTimeout(() => {
        gridref2.current.api.setFocusedCell(
          gridref2.current.api.getDisplayedRowCount() - 1,
          "cd_matl"
        );
      }, 50);*/
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const onGrid2BtnsClick = async (id: string) => {
    if (id == "addRow") {
      onAddRow();
    }
    if (id == "deleteRow") {
      onDeleteRow();
    }
  };
  //region onAddRow
  const onAddRow = async () => {
    try {
      if (gridref1.current.getSelectedRow()[0].cd_item == "") {
        await showDialog("alter", "품목을 선택 후 행추가 해주시기 바랍니다.");
        return;
      }
      const newRow = {};
      gridref2.current?.addRow(newRow);
    } catch (error: any) {}
  };

  //region onDeleteRow
  const onDeleteRow = async () => {
    gridref2.current?.deleteSelectedRows();
  };
  const onBeforeAddRowH = (newRow: RowData): boolean => {
    try {
      const formData = searchRef.current.getFormdata();
      const selectedCd_item = formData.cd_item;

      const updatedRow = {
        cd_firm: userInfo.cd_firm,
        cd_item: selectedCd_item,
        nm_item: formData[""],
      };

      Object.assign(newRow, updatedRow);
      return true;
    } catch (error: any) {
      return false;
    }
  };
  const onBeforeAddRowL = (newRow: RowData): boolean => {
    try {
      const selectedRows = gridref1.current.api.getSelectedNodes();
      //gridref1.current.selectAndFocusRow(selectedRows[0].rowIndex);
      /*gridref2.current.applyFilters({
        cd_item: selectedRows[0]?.data.cd_item,
      });*/
      const selectedCd_item = selectedRows[0]?.data.cd_item;
      const formData = searchRef.current.getFormdata();
      const allRowData: any[] = [];
      gridref2.current.api.forEachNodeAfterFilterAndSort((node: any) => {
        allRowData.push(node.data);
      });

      const maxNoLine = allRowData
        .filter((row: any) => row.cd_item === selectedCd_item)
        .map((row: any) => row.no_line || 0)
        .reduce((max, current) => Math.max(max, current), 0);
      var cdEquipFromLastRow = "";
      const rowCount = gridref2.current.api.getDisplayedRowCount();
      if (rowCount > 1) {
        const lastRowNode = gridref2.current.api.getDisplayedRowAtIndex(
          rowCount - 1
        );
        cdEquipFromLastRow = lastRowNode?.data?.cd_equip || "";
      }

      const updatedRow = {
        cd_firm: userInfo.cd_firm,
        cd_biz: userInfo.cd_biz,
        cd_item: selectedCd_item,
        dc_item_spec_matl: selectedRows[0]?.data.dc_item_spec,
        dc_item_unit_matl: selectedRows[0]?.data.dc_item_unit,
        cd_equip:
          formData.cd_equip == "" ? cdEquipFromLastRow : formData.cd_equip,
        no_line: maxNoLine + 1,
        qt_unit: 1,
      };

      Object.assign(newRow, updatedRow);
      return true;
    } catch (error: any) {
      return false;
    }
  };

  const onDelete = async () => {
    gridref2.current?.deleteSelectedRows();
  };

  const onSave = async () => {
    try {
      gridref2.current.api.stopEditing();

      const requiredValuesCheck = gridref2.current.requiredValuesCheck();
      if (!requiredValuesCheck) {
        return;
      }

      const gridGetChanges = gridref2.current.getChange();
      if (gridGetChanges.modifiedRowcount == 0) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }
      const gridData: any[] = [];
      gridref2.current.api.forEachNodeAfterFilterAndSort((node: any) => {
        gridData.push(node.data);
      });

      if (!checkForDuplicates(gridData)) return;

      SaveData["prd_putitem_pos"] = gridref2.current.getChange();

      await fnSave("SN_PRD_BAS_REG_014_SAVE_01", SaveData);

      gridref2.current.resetUpdate();
      SaveData = [];
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };
  const onExcelUpload = async () => {
    try {
      const component = (
        <SN_PRD_BAS_REG_014_POP_01
          Menuprops={Menuprops} // 메뉴 정보 전달
          PkFields={["cd_pos", "no_line", "ct_matl", "cd_item"]} // PK 필드 목록 전달
          tableName="prd_putitem_pos" // 저장할 테이블 이름
          controllerName="SN_PRD_BAS_REG_014_SAVE_01" // 저장할 컨트롤러 이름
          userInfo={userInfo}
        />
      );

      const result = await showPopupModal({
        title: "엑셀 업로드",
        children: component,
        width: "80%",
        height: "90VH",
        okayBtnText: "저장",
      });

      if (result) {
        console.log("엑셀 업로드 완료:", result);
      } else {
        console.log("엑셀 업로드 취소됨");
      }
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const onExcelDownLoad = async () => {
    try {
      if (!sheetReady) {
        await new Promise((resolve) => setTimeout(resolve, 100));
      }
      // 1. 컬럼 키 정의
      const columnKeys = sheet1Columns.map((col) => col.cd_column);
      // 2. gridref2에서 데이터 가져오기
      const grid2Data: any[] = [];
      gridref2.current?.api?.forEachNodeAfterFilterAndSort((node: any) => {
        if (node.data) grid2Data.push(node.data);
      });

      // 3. sheetref1에 rowData 바인딩
      const allRows: any[] = [];
      sheetref1.current?.api?.forEachNodeAfterFilterAndSort((node: any) => {
        if (node.data) allRows.push(node.data);
      });
      if (allRows.length) {
        sheetref1.current?.api?.applyTransaction({ remove: allRows });
      }

      // grid2 데이터 추가
      if (grid2Data.length) {
        sheetref1.current?.api?.applyTransaction({ add: grid2Data });
      }
      const flatRowMap = sheetref1.current.getFlatDataFromGrid(columnKeys);

      sheetref1.current?.api.exportDataAsExcel({
        columnKeys,
        skipPinnedBottom: true,
        fileName: globalMenu.getState().activeMenuInfo.nm_menu + ".xlsx",
        sheetName: "Sheet1",
        processCellCallback: (params: ProcessCellForExportParams) => {
          const row = flatRowMap.get(params.node?.id ?? "");
          return row?.[params.column.getColId()]?.value ?? "";
        },
      });
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const checkForDuplicates = (gridData: any[]): boolean => {
    const seen = new Set();

    for (const row of gridData) {
      const key = `${row.cd_firm}|${row.cd_pos}|${row.cd_item}|${row.cd_matl}`;
      if (seen.has(key)) {
        showDialog("error", `장비위치 [${row.cd_pos}]가 이미 등록 되었습니다`);
        return false;
      }
      seen.add(key);
    }

    return true;
  };
  const onCellValueChangedH = async (event: any) => {
    if (!event) return;
    const updatedColumnId = event.column.getColId();
    const updatedRow = event.data;
    if (updatedColumnId == "cd_item") {
      gridref2.current.applyFilters({ cd_item: updatedRow.cd_item });
    }
  };

  // Usage

  //#endregion

  // grid1의 width resize
  const onResizeStopH = (width: number) => {
    setGrid1Width(width);
  };

  // grid2의 width resize
  const onResizeStopL = (width: number) => {
    setGrid2Width(width);
  };

  //#region  Event Method
  const onFocusedRowChanged = (event: any) => {
    const selectedRow = event; // 클릭한 행 데이터
    if (selectedRow) {
      // 배열로 만들어서 필터링 함수 호출
      const cd_item = selectedRow.cd_item;

      gridref2.current.applyFilters({
        cd_item: cd_item,
      });
      gridref2.current.selectAndFocusRow(0);
    } else {
      return;
    }
  };
  //#endregion

  //#region UI
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
          
        ></SearchPanel>
      </div>
      <div className="w-full flex space-x-2 flex-grow overflow-x-hidden">
        <SnResizableLNR
          width={grid1Width}
          minWidth={130}
          onResizeStop={onResizeStopH}
          enable={{ right: true }}
          menuName={Menuprops.cd_menu || "SN_PRD_BAS_REG_014"}
          defaultSize={{ grid1Width: grid1Width }}
        >
          <SnGrid
            seq={1}
            ref={gridref1}
            
            enableAddRow={true}
            columnConfig={columns1} // 컬럼 설정 전달
            rowData={dataSource1}
            enableExternalChart={false}
            isEditable={true}
            rowSelection="single" // 단일 선택 모드
            onFocusedRowChanged={onFocusedRowChanged}
            title="품목정보" // 그리드 타이틀 정보
            onBeforeAddRow={onBeforeAddRowH}
            onCellValueChanged={onCellValueChangedH}
            cellSelection={false}
          />
        </SnResizableLNR>
        <SnResizableLNR
          width={grid2Width}
          minWidth={860}
          onResizeStop={onResizeStopL}
          enable={{ right: true }}
          menuName={Menuprops.cd_menu || "SN_PRD_BAS_REG_014"}
          defaultSize={{ grid2Width: grid2Width }}
        >
          <SnGrid
            seq={2}
            ref={gridref2}
            
            enableAddRow={true}
            columnConfig={columns2} // 컬럼 설정 전달
            rowData={dataSource2}
            enableExternalChart={false}
            title="상세정보" // 그리드 타이틀 정보
            onBtnAddClick={onGrid2BtnsClick}
            onBtnDeleteClick={onGrid2BtnsClick}
            rowSelection="multiple" // 단일 선택 모드
            onBeforeAddRow={onBeforeAddRowL}
            cellSelection={true}
            isEditable={true}
          />
        </SnResizableLNR>
      </div>
      <div style={{ display: "none" }}>
        <SnGrid
          
          ref={sheetref1}
          columnConfig={sheet1Columns}
          rowData={[]} // 초기에는 비어도 됨, setRowData로 넣을 거라서
          isEditable={false}
          onGridReady={() => setsheetReady(true)}
        />
      </div>
    </div>
  );
  //#endregion
});

export default SN_PRD_BAS_REG_014;
